import {InjectionToken} from '@angular/core';

export const CORE_CONFIGURATION = new InjectionToken<CoreOptions>('CORE_CONFIGURATION');

export interface CoreOptions {
  production?: boolean;
  environment?: string;
  apiHost?: string;
  apiHostAWS?: string;
  apiKeycloakHost?: string;
  apiBasePath?: string;
  aemBasePath?: string;
  secondaryApiHost?: string;
  enableTracing?: boolean;
  isInEditor?: boolean;
  errorPageAccessDenied?: string;
  errorPageNotFound?: string;
}
